export default __webpack_public_path__ + "static/media/chat-typing-indicator.d7a49a75.gif";